var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", {}, [
    _c("div", {
      directives: [
        {
          name: "video-player",
          rawName: "v-video-player:myVideoPlayer",
          value: _vm.playerOption,
          expression: "playerOption",
          arg: "myVideoPlayer"
        }
      ],
      staticClass: "video-player-box",
      attrs: { playsinline: _vm.playsinline }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }